import {
    IS_LOYALTY_NOT_FOUND
} from "../../../actions/types";

const INITIAL_STATE = {
    isLoyaltyNotFound: false
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case IS_LOYALTY_NOT_FOUND:
            return {
              isLoyaltyNotFound: action.payload
            }
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/restaurants/loyalty/LoyaltyErrorResponseReducer.js